$(document).ready(function () { 
  
    var $slider = $(".bnr-carousel");
    var slideCount = $slider.children().length; // Count the slides
    if (slideCount > 1) {
        $slider.slick({
            infinite: true,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false
        });
    } else {
        $slider.slick({
            infinite: true,
            dots: false, // Hide dots if only one slide
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false
        });
    }

$('.our_collection').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      dots: false,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'30px',
        }
      }
    ]
    });

    // Custom Prev Arrow Button
    $('#ourPrdsPrev').on('click', function () {
      $('.our_collection').slick('slickPrev');
    });

    // Custom Next Arrow Button
    $('#customPrdsNext').on('click', function () {
      $('.our_collection').slick('slickNext');
    });




  $('.featured-pro').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      dots: false,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'30px',
        }
      }
    ]
    });

    // Custom Prev Arrow Button
    $('#ourPrdsPrev').on('click', function () {
      $('.our_collection').slick('slickPrev');
    });

    // Custom Next Arrow Button
    $('#customPrdsNext').on('click', function () {
      $('.our_collection').slick('slickNext');
    });



  //------- product details tab section--------

  const tabWrapper = document.querySelector(".tabswrapper .tabs");

  if (!tabWrapper) return; // Stop execution if the tab section doesn't exist

  const tabButtons = tabWrapper.querySelectorAll("[role='tab']");
  const tabPanels = Array.from(tabWrapper.querySelectorAll("[role='tabpanel']"));

  function tabClickHandler(e) {
    tabPanels.forEach((panel) => (panel.hidden = true));
    tabButtons.forEach((button) => button.setAttribute("aria-selected", "false"));

    e.currentTarget.setAttribute("aria-selected", "true");
    const selectedTab = tabPanels.find(
      (panel) => panel.getAttribute("aria-labelledby") === e.currentTarget.id
    );
    if (selectedTab) selectedTab.hidden = false;
  }

  tabButtons.forEach((button) => button.addEventListener("click", tabClickHandler));
  
}); //end of document.ready function





  $('.featured_col_slick').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      dots: false,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'30px',
        }
      }
    ]
    });

    // Custom Prev Arrow Button
    $('#ftrdColPrv').on('click', function () {
      $('.featured_col_slick').slick('slickPrev');
    });

    // Custom Next Arrow Button
    $('#ftrdColNxt').on('click', function () {
      $('.featured_col_slick').slick('slickNext');
    });

// -----see more and see less truncated-text for collection, page and blog archive------
 document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".truncated-text").forEach(function (element) {
        let fullText = element.innerHTML.trim();
        let words = fullText.split(" ");
        let wordLimit = 50;

        if (words.length > wordLimit) {
            let truncatedText = words.slice(0, wordLimit).join(" ") + "...";

            // Create truncated and full text elements
            let truncatedSpan = document.createElement("span");
            truncatedSpan.classList.add("truncated-content");
            truncatedSpan.innerHTML = truncatedText;

            let fullSpan = document.createElement("span");
            fullSpan.classList.add("full-text");
            fullSpan.style.display = "none"; // Ensure full text is hidden initially
            fullSpan.innerHTML = fullText;

            let showMoreButton = document.createElement("button");
            showMoreButton.textContent = "Show More";
            showMoreButton.classList.add("show-more");

            // Clear the element and append new elements
            element.innerHTML = "";
            element.appendChild(truncatedSpan);
            element.appendChild(fullSpan);
            element.appendChild(showMoreButton);

            showMoreButton.addEventListener("click", function () {
                let isHidden = fullSpan.style.display === "none";
                fullSpan.style.display = isHidden ? "inline" : "none";
                truncatedSpan.style.display = isHidden ? "none" : "inline";
                showMoreButton.textContent = isHidden ? "Show Less" : "Show More";
            });
        }
    });
  });